import Config from '../components/common/Config';
import { joinApiUrl, postEncryptedForm } from './eposApi';

function resolveBearerToken(bearerToken) {
  return bearerToken || localStorage.getItem('token') || localStorage.getItem('accessToken');
}

export async function postCreatePickingList(plainPayload, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedForm(
    joinApiUrl(Config.API_URL, 'create/picking'),
    token,
    plainPayload
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}

export async function postPickingHistory(plainPayload, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedForm(
    joinApiUrl(Config.API_URL, 'picking/get'),
    token,
    plainPayload
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}

export async function postCreatePicking(plainPayload, bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedForm(
    joinApiUrl(Config.API_URL, 'create_picking'),
    token,
    plainPayload
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}

export async function fetchGetPicker(bearerToken) {
  const token = resolveBearerToken(bearerToken);
  const { response, data } = await postEncryptedForm(
    joinApiUrl(Config.API_URL, 'getPicker'),
    token,
    {}
  );
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return data;
}
